import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ItemModule} from '../../../../../../core/component/item/item.module';
import {MedicalRecordPainMultipleSelectFilterComponent} from './medical-record-pain-multiple-select-filter.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MultipleSelectFilterDataModule} from '../../../../../../core/component/multiple-select-filter-data/multiple-select-filter-data.module';
import {
    MedicalRecordPainCreateUpdateModule
} from '../medical-record-pain-create-update/medical-record-pain-create-update.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        FormsModule,
        ItemModule,
        MultipleSelectFilterDataModule,
        MedicalRecordPainCreateUpdateModule,
    ],
    declarations: [
        MedicalRecordPainMultipleSelectFilterComponent,
    ],
    exports: [
        MedicalRecordPainMultipleSelectFilterComponent
    ],
})
export class MedicalRecordPainMultipleSelectFilterModule {
}
